/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-09 11:02:40
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 14:15:20
 */
import { checkAuthorize } from '@/api/shopManage';
import { startAuthorize, addAuthorize } from '@/api/teamManage';
export default {
	methods: {
		/**
		 * 验证是否授权
		 * @param {*} platform_id
		 * @returns
		 */
		async fetchAuthInfo(platform_id) {
			try {
				const params = { platform_id };
				const data = await checkAuthorize(params);
				return Promise.resolve(data);
			} catch (error) {
				return Promise.reject();
			}
		},
		/**
		 * 获取授权的链接跟call_id
		 */
		getAuthLink(platformId, type = 0, institutionId = '') {
			let apiMap = new Map([
				[0, addAuthorize],
				[1, startAuthorize],
			]);
			let params = { platformId: platformId };
			if (type === 1) params.institutionId = institutionId;
			return new Promise(async rs => {
				const data = await apiMap.get(type)(params);
				return rs(data);
			});
		},
		/**
		 * @description 用于检测用户是否已授权第三方平台，如果未授权：
		 * @param {*} platformId 平台ID
		 * @returns
		 */
		checkAuth(platformId, type = 0, institutionId = '') {
			return new Promise(async (rs, rj) => {
				const data = await this.fetchAuthInfo(platformId);
				if (!data.bind_status) {
					this.checkAuthAdd(platformId, type, institutionId);
					return rj('未授权');
				}
				return rs();
			});
		},
		/**
		 * 授权
		 */
		async checkAuthAdd(platformId, type = 0, institutionId = '') {
			const { data, code } = await this.getAuthLink(platformId, type, institutionId);
			if (code !== 0) return;
			this.handleNeedBind(data.institution_url, platformId, data.call_id);
		},
		/**
		 *
		 * @param {*} link
		 * @param {*} platformId
		 * @param {*} call_id
		 */
		handleNeedBind(link, platformId, call_id) {
			this.$refs.authAlertDialog.init(link, platformId, call_id);
		},
	},
};
